import React from "react"
import { SvgCheckCircle } from "../icons"

interface Props {
  payInFull: boolean
  setPayInFull: React.Dispatch<React.SetStateAction<boolean>>
}

const FlexPaymentOptions: React.FC<Props> = ({ payInFull, setPayInFull }) => {
  return (
    <div className="mb-[24px] rounded-[16px] border bg-white p-[20px]">
      <div className="flex gap-[12px]">
        <button
          type="button"
          onClick={() => setPayInFull(true)}
          className={`flex-1 rounded-[12px] border p-[16px] text-left transition ${
            payInFull
              ? "border-blurple bg-blurple/5"
              : "border-grayCloud hover:border-graySlate"
          }`}
        >
          <div className="flex items-center justify-between">
            <span className="font-medium">Pay in full</span>
            {payInFull && <SvgCheckCircle className="h-4 w-4 text-blurple" />}
          </div>
          <p className="mt-[4px] text-sm text-graySlate">
            One-time payment today
          </p>
        </button>

        <button
          type="button"
          onClick={() => setPayInFull(false)}
          className={`flex-1 rounded-[12px] border p-[16px] text-left transition ${
            !payInFull
              ? "border-blurple bg-blurple/5"
              : "border-grayCloud hover:border-graySlate"
          }`}
        >
          <div className="flex items-center justify-between">
            <span className="font-medium">Pay in installments</span>
            {!payInFull && <SvgCheckCircle className="h-4 w-4 text-blurple" />}
          </div>
          <p className="mt-[4px] text-sm text-graySlate">
            Split across multiple payments
          </p>
        </button>
      </div>
    </div>
  )
}

export default FlexPaymentOptions
